import { render } from "./Powered.vue?vue&type=template&id=07995bd4"
import script from "./Powered.vue?vue&type=script&lang=js"
export * from "./Powered.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ferha\\workspace\\calculus\\digyinfo-demo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__